import SdlBreadcrumb from './Breadcrumb';

export default SdlBreadcrumb;



// WEBPACK FOOTER //
// ./src/components/common/control/breadcrumb/index.js